'use strict';
mpangoApp.controller('McontributionsController',McontributionsController);
function McontributionsController($rootScope,$scope,$state,$window,Mreports,Mcontribution, Notification, $filter, SweetAlert, $uibModal) {
	$scope.$on('$viewContentLoaded', function () {
        Mcontribution.getContr().success(function  (data,status) {
            $scope.mcontributions = data.contr;
            $scope.cPledgesn = 0;
            $scope.pPledgesn = 0;
            var contrs = data.contr;
            for (var i = contrs.length - 1; i >= 0; i--) {
                if (contrs[i].status === "complete" && contrs[i].c_pledge > 0) {
                    $scope.cPledgesn += 1;
                }
                if (contrs[i].status === "pending") {
                    $scope.pPledgesn += 1;
                }
            }
        }).error(function(data,status){
            $state.go('auth');
            Notification.error({message: 'Token expired, please login', delay: 3000});
        });
    });
    $scope.sort = function(keywoo){
        $scope.sortKey = keywoo;   
        $scope.reverse = !$scope.reverse; 
    }
    $scope.currentPage = 1;
    $scope.pageSize = 10;
    $scope.pageChangeHandler = function(num) {};
    $scope.openc = function  (templatename,size,xtype) {
        var modalInstance = $uibModal.open({
            templateUrl: templatename,
            keyboard: false,
            backdrop: 'static',
            size: size,
            resolve:{
                tablename:function  () {
                    return $scope.mcontributions;
                }
            },
            controller: function  ($scope,tablename, $uibModalInstance) {
                $scope.add = function  (contrdata,valid) {
                    if (valid == true) {
                        $uibModalInstance.close();
                        Mcontribution.postContr(contrdata).success(function  (data,status) {
                            $scope.mcontributions = tablename;
                            $scope.mcontributions.push(data.insertedD);
                            Notification.success({message: data.message});
                        }).error(function(data,status){
                            $state.go('auth');
                            Notification.error({message: 'Token expired, please login', delay: 3000});
                        }); 
                    }
                };
                $scope.addXls = function  (xlsdata,valid) {
                    if (valid == true) {
                        $uibModalInstance.close();
                        Mcontribution.postXls(xlsdata).success(function  (data,status) {
                            $state.reload();
                            Notification.success({message: data.message});
                        }).error(function(data,status){
                            $state.go('auth');
                            Notification.error({message: 'Token expired, please login', delay: 3000});
                        }); 
                    }
                };
                $scope.cancel = function  () {
                    $uibModalInstance.dismiss('cancel');
                };
                $scope.printSelectedDoc = function(tempname,id,field_name) {
                    $uibModalInstance.close();
                    Mreports.toExcel(tempname,xtype,id,field_name).success(function  (data,status) {
                        var token = $rootScope.sytoken;
                        var url = 'index.php/api/toexcel?data='+tempname+'&eId='+id+'&xtype='+xtype+'&limit='+field_name+'&token='+token;
                        $window.open(url);           
                    }).error(function(data,status){
                        $state.go('auth');
                        Notification.error({message: 'Token expired, please login', delay: 3000});
                    });
                };
            }
        });
    };
    $scope.update = function(contr,formname,index) {
        var cPledge = parseInt(contr.c_pledge);
        var cPaid = parseInt(contr.c_paid);
        if ( cPledge >= cPaid) {
            SweetAlert.swal({
                title: "Are you sure?",
                text: "Update contributor data",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",confirmButtonText: "Yes!",
                cancelButtonText: "No, cancel!",
                closeOnConfirm: true,
                closeOnCancel: true }, 
            function(isConfirm){ 
                if (isConfirm) {
                    Mcontribution.updateContr(contr,formname).success(function(data) {
                        $state.reload();
                        Notification.success({message: data.message});
                    }).error(function(data,status){
                        $state.go('auth');
                        Notification.error({message: 'Token expired, please login', delay: 3000});
                    });
                 
                } else {
                  SweetAlert.swal("Cancelled", "Your data is safe!", "error");
                }
            });
            
        }else if(formname == 'delete'){
            SweetAlert.swal({
                title: "Are you sure?",
                text: "Delete contributor data",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",confirmButtonText: "Yes,delete!",
                cancelButtonText: "No, cancel!",
                closeOnConfirm: true,
                closeOnCancel: true }, 
            function(isConfirm){ 
                if (isConfirm) {
                    Mcontribution.updateContr(contr,formname).success(function(data) {
                        $scope.mcontributions.splice(index, 1);
                        Notification.success({message: data.message});        
                    }).error(function(data,status){
                        $state.go('auth');
                        Notification.error({message: 'Token expired, please login', delay: 3000});
                    });
                } else {
                  SweetAlert.swal("Cancelled", "Your data is safe!", "error");
                }
            });
        }
        else{
            Notification.error({message:'Error: Amount pledged should be greater or equal to amount paid', delay: 5000});
        }   
    };
    $scope.initPrintOptions = function() {
        $scope.printOptions = [
        {'field_name':'all','name':'All contribution'},
        { 'field_name': 'without_zero_all', 'name': 'Without zero pledge( all )' },
        { 'field_name': 'without_zero_card', 'name': 'Without zero pledge( card )' },
        {'field_name':'without_zero_pledge','name':'Without zero pledge( pledge )'},
        { 'field_name': 'complete_all', 'name': 'Complete status( all )' },
        { 'field_name': 'complete_card', 'name': 'Complete status( card )' },
        {'field_name':'complete_pledge','name':'Complete status( pledge )'},
        {'field_name':'pending','name':'Pending status'}
        ]
    }

    $scope.contributionType = [
        { 'id': 'Pledge', 'name': 'Pledge' },
        { 'id': 'Card', 'name': 'Card' }
    ]
}
McontributionsController.$inject = ['$rootScope','$scope','$state','$window','Mreports','Mcontribution', 'Notification', '$filter', 'SweetAlert', '$uibModal'];